import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale("en-gb");                    // DD/MM/YYYY conventions

// Set default timezone to Asia/Riyadh for Saudi Arabia
dayjs.tz.setDefault("Asia/Riyadh");

export default dayjs;
